import moment from 'moment';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';
import { ChanelConfig } from '../../../../../configs/GlobalConfig';
import messageHub from '../../../../../core/signalr/SignalrMessageHub';
import DropDown from '../../../../common/dropdown/DropDown';
import Loading from '../../../../common/loading/Loading';
import Tab from '../../../../common/tab-timer';
import Tooltip from '../../../../common/tooltip/SimpleTooltip';
import { getQueryParams } from '../../../../helpers/Common';
import { formatTextFloat } from '../../../../helpers/Text';
import { getFormatter, isFormatBillion } from '../../helper';
import { setRealtimeData } from '../../reducer';
import { mapTimesToValue, TIMES, XS_SIZE } from './Const';
import TreeMap from './TreeMap';
import { connect } from 'react-redux';
import { REDUCER_NAME } from './../../reducer';

const mapQueryTime = {
  Today: TIMES.TODAY,
  FiveDays: TIMES.ONE_WEEK,
  TwentyDays: TIMES.ONE_MONTH,
  YTD: TIMES.YEAR_TO_DATE,
};

const getCurrentTypeIndex = () => {
  const mapCriteria = {
    ForeignValue: 0,
    NetForeignValue: 1,
  };

  return mapCriteria[getQueryParams('critera')] === undefined
    ? 1
    : mapCriteria[getQueryParams('critera')];
};

class BuySellTreeMap extends PureComponent {
  constructor(props) {
    super(props);
    const queryFilter = mapQueryTime[getQueryParams('timeRange')];
    this.state = {
      currentFilter: queryFilter || TIMES.TODAY,
      calcIndex: 0,
      currentType: (this.props.dropdown.ids || [])[getCurrentTypeIndex()],
    };
  }

  componentDidMount() {
    const { isRealtimeTicker } = this.props;
    if (isRealtimeTicker) {
      messageHub.subscribe(ChanelConfig.TickChanel, this.onReceiveTickers);
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { calcIndex } = this.state;
    const { data } = this.props;
    if (data !== nextProps.data) {
      this.setState({
        calcIndex: calcIndex + 1,
      });
    }
  }

  componentWillUnmount() {
    const { isRealtimeTicker } = this.props;
    if (isRealtimeTicker) {
      messageHub.unsubscribe(ChanelConfig.TickChanel, this.onReceiveTickers);
    }
  }

  onReceiveTickers = tickers => {
    const { setRealtimeData } = this.props;
    setRealtimeData(tickers);
  };

  changeFilter = filter => {
    const { calcIndex } = this.state;
    this.setState({
      currentFilter: filter,
      calcIndex: calcIndex + 1,
    });
  };

  changeCurrentType = value => {
    const { calcIndex } = this.state;
    this.setState({
      currentType: value,
      calcIndex: calcIndex + 1,
    });
  };

  isXsSize = () => {
    const { component } = this.props;

    return component && component.width < XS_SIZE;
  };

  getWrapperClassName = () => {
    return this.isXsSize() ? 'flex-column' : 'flex-row';
  };

  getSellTreeMapClassName = () => {
    return this.isXsSize() ? 'mt-10' : 'ml-10';
  };

  getBuyPercent = currentData => {
    const { buyAttr, sellAttr } = this.getValueAttr();

    return (
      Math.abs(currentData[buyAttr]) /
      (Math.abs(currentData[buyAttr]) + Math.abs(currentData[sellAttr]))
    );
  };

  getSellPercent = currentData => {
    const { buyAttr, sellAttr } = this.getValueAttr();

    return (
      Math.abs(currentData[sellAttr]) /
      (Math.abs(currentData[buyAttr]) + Math.abs(currentData[sellAttr]))
    );
  };

  getFromAndToDate = currentData => {
    return {
      from: moment(currentData.fromDate).format('L'),
      to: moment(currentData.toDate).format('L'),
    };
  };

  getTooltipText = () => {
    const { currentFilter } = this.state;
    const { data } = this.props;
    const currentData = data[mapTimesToValue[currentFilter]];
    if (mapTimesToValue[currentFilter] === TIMES.TODAY) {
    }

    const i18nKey =
      currentFilter === TIMES.TODAY
        ? 'moneyFlowCommon.tooltipToday'
        : 'moneyFlowCommon.tooltipDate';

    return I18n.t(i18nKey, this.getFromAndToDate(currentData));
  };

  isTypeValue = () => {
    const currentType = this.getType();

    return currentType === 'VALUE';
  };

  getTitles = () => {
    const { currentFilter } = this.state;
    const { data } = this.props;
    const currentData = data[mapTimesToValue[currentFilter]] || {};
    const { buyAttr, sellAttr } = this.getValueAttr();
    const maxValue = Math.max(
      Math.abs(currentData[buyAttr]),
      Math.abs(currentData[sellAttr]),
    );
    if (!this.isTypeValue()) {
      if (!isFormatBillion(maxValue)) {
        return {
          buyTitle: 'moneyFlowProprietary.treeMapMilNetBuyTitle',
          sellTitle: 'moneyFlowProprietary.treeMapMilNetSellTitle',
        };
      }

      return {
        buyTitle: 'moneyFlowProprietary.treeMapNetBuyTitle',
        sellTitle: 'moneyFlowProprietary.treeMapNetSellTitle',
      };
    }

    if (!isFormatBillion(maxValue)) {
      return {
        buyTitle: 'moneyFlowProprietary.treeMapTickerBuyTitle',
        sellTitle: 'moneyFlowProprietary.treeMapTickerSellTitle',
      };
    }

    return {
      buyTitle: 'moneyFlowProprietary.treeMapBuyTitle',
      sellTitle: 'moneyFlowProprietary.treeMapSellTitle',
    };
  };

  getBuyField = () => {
    const currentType = this.getType();

    return currentType === 'VALUE' ? 'buy' : 'netBuy';
  };

  getSellField = () => {
    const currentType = this.getType();

    return currentType === 'VALUE' ? 'sell' : 'netSell';
  };

  getType = () => {
    const { currentType } = this.state;
    const { isTicker, dropdown } = this.props;
    if (isTicker) {
      return dropdown.ids[0];
    }

    return currentType;
  };

  getValueAttr = () => {
    const { buyKey, sellKey, netSellKey, netBuyKey } = this.props;

    if (this.isTypeValue()) {
      return {
        sellAttr: sellKey,
        buyAttr: buyKey,
      };
    }

    return {
      sellAttr: netSellKey,
      buyAttr: netBuyKey,
    };
  };

  render() {
    const { currentFilter, calcIndex } = this.state;

    const {
      data,
      isLoading,
      height,
      buyKey,
      sellKey,
      renderSellTooltip,
      renderBuyTooltip,
      isRealtimeTicker,
      dropdown,
      isTicker,
    } = this.props;
    const currentType = this.getType();
    const currentData = data[mapTimesToValue[currentFilter]] || {};
    const { buyAttr, sellAttr } = this.getValueAttr();
    const { buyTitle, sellTitle } = this.getTitles();

    if (isLoading) {
      return <Loading />;
    }
    const formatter = getFormatter(
      Math.max(Math.abs(currentData[buyAttr]), Math.abs(currentData[sellAttr])),
    );

    return (
      <div
        key={calcIndex}
        className={`flex-fill d-flex flex-column position-relative buy-sell-tree-map-wrapper ${
          isLoading ? 'bg-blur' : ''
        }`}
      >
        <div className="d-flex justify-content-between align-items-center flex-wrap flex-shrink-0">
          <div className="d-flex align-items-center flex-wrap">
            <Tab
              disableTabNormal={true}
              currentTab={currentFilter}
              listTab="moneyFlowProprietary.timeTab"
              changeTab={this.changeFilter}
            />
          </div>

          <div className="align-items-center d-flex">
            <div className="list-filter mr-5 mb-5">
              <div className="line-drop">
                {!isTicker && (
                  <DropDown
                    isI18n
                    currentKey={this.getType()}
                    listKey={dropdown.ids}
                    listDataByKey={dropdown.data}
                    change={this.changeCurrentType}
                  />
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`flex-fill d-flex ${this.getWrapperClassName()} buy-sell-tree-map position-relative`}
        >
          <div
            style={{
              flex: isNaN(this.getBuyPercent(currentData))
                ? 1
                : this.getBuyPercent(currentData),
            }}
            className="tree-map-wrapper d-flex flex-column"
          >
            <TreeMap
              currentType={currentType}
              currentFilter={currentFilter}
              isRealtimeTicker={isRealtimeTicker}
              renderTooltip={renderBuyTooltip}
              valueAttr={buyAttr}
              height={height}
              title={
                <Translate
                  value={buyTitle}
                  tradeValue={formatTextFloat(
                    formatter(Math.abs(currentData[buyAttr])),
                  )}
                />
              }
              noDataTitleKey="moneyFlowCommon.noDataBuy"
              data={currentData[this.getBuyField()]}
            />
          </div>

          <div
            style={{
              flex: isNaN(this.getSellPercent(currentData))
                ? 1
                : this.getSellPercent(currentData),
            }}
            className={`tree-map-wrapper d-flex flex-column ${this.getSellTreeMapClassName()}`}
          >
            <TreeMap
              currentType={currentType}
              currentFilter={currentFilter}
              isRealtimeTicker={isRealtimeTicker}
              renderTooltip={renderSellTooltip}
              valueAttr={sellAttr}
              height={height}
              title={
                <Translate
                  value={sellTitle}
                  tradeValue={formatTextFloat(
                    formatter(Math.abs(currentData[sellAttr])),
                  )}
                />
              }
              noDataTitleKey="moneyFlowCommon.noDataSell"
              data={currentData[this.getSellField()]}
            />
          </div>
        </div>
        {currentData && currentData.fromDate && currentData.toDate && (
          <div className="footer-note">{this.getTooltipText()}</div>
        )}
      </div>
    );
  }
}

BuySellTreeMap.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
  height: PropTypes.number,
  buyKey: PropTypes.string,
  sellKey: PropTypes.string,
  netBuyKey: PropTypes.string,
  netSellKey: PropTypes.string,
  renderBuyTooltip: PropTypes.func.isRequired,
  renderSellTooltip: PropTypes.func.isRequired,
  isRealtimeTicker: PropTypes.bool,
  setRealtimeData: PropTypes.func.isRequired,
};

BuySellTreeMap.defaultProps = {
  isLoading: false,
  data: null,
  height: null,
  buyKey: 'totalBuyTradeValue',
  sellKey: 'totalSellTradeValue',
  netBuyKey: 'foreignNetBuyValue',
  netSellKey: 'foreignNetSellValue',
  isRealtimeTicker: false,
  dropdown: {},
};

const mapStateToProps = state => ({
  component: state[REDUCER_NAME].component,
  i18n: state.i18n,
});

const mapDispatchToProps = {
  setRealtimeData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BuySellTreeMap);
